import React from "react";

const initials = (account) => {
    const f = (account?.first_name || "").trim();
    const l = (account?.last_name || "").trim();
    if (f || l) return ((f[0] || "") + (l[0] || "")).toUpperCase();
    return (account?.email || "?").substring(0, 1).toUpperCase();
};

const AccountIdentityBar = ({ account, planLabel, onPlanClick }) => {
    const name = `${account?.first_name || ""} ${account?.last_name || ""}`.trim() || account?.email;
    return (
        <div className="acc-idbar">
            <div className="acc-avatar">{initials(account)}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <div className="acc-id-name">{name}</div>
                <div className="acc-id-sub">{account?.email}</div>
            </div>
            {planLabel &&
                <span className="acc-plan" onClick={onPlanClick}>
                    <i className="pi pi-bolt" style={{ fontSize: 12, marginRight: 5 }} />{planLabel}
                </span>}
        </div>
    );
};
export default AccountIdentityBar;
